import { ScmConfigs } from "../types";
import { ScmConfigsList } from "./ScmConfigsList";
import { ScmConfigsEdit } from "./ScmConfigsEdit";

export default {
  list: ScmConfigsList,
  edit: ScmConfigsEdit,
  recordRepresentation: (record: ScmConfigs) =>
    `${record.id}. ${record.nome_reduzido}`,
};
